import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import MrlSingleReview from "../Components/MrlSingleReview";
export default class ReviewsPage extends React.Component{
	constructor(props){
		super(props);

		this.state = {
			reviews: []
		};
	}

	updateData(){
		this.loadData(r => {
			this.setState({
				reviews: r
			});
		})
	}

	componentDidMount(){
		// Fetch and set timer
		this.updateData();

		this.timer1 = setInterval(() => {
			this.updateData()
		}, (1 + 3 * Math.random()) * 1000);		
	}

	componentWillUnmount(){
		// Remove timer
		clearInterval(this.timer1);
	}

	loadData(callback){
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch('https://www.mattiamerlini.it/api/reviews/reviews', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                var data = isJson && await response.json();

                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response status
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                }

				callback(data);
            })
            .catch(error => {
                //callback()
                console.error('There was an error!', error);
				callback([]);
            });
    }

	getColor(){ 
		return "hsl(" + 360 * Math.random() + ',' +
				   (25 + 70 * Math.random()) + '%,' + 
				   (85 + 10 * Math.random()) + '%)'
	}

    render(){	

        return(        
			<main className="mrl-main container">
				<div className='container text-center mb-5 mt-5'>
					<div className="row align-items-center" >
						<div className="col-md-4 mb-5">
							<img
								src="https://mattiamerlini.it/image/mattia-merlini-in-piedi-1.png"
								alt="Mattia Merlini"
								loading="lazy"
								className='img-fluid'
							/>
						</div>
						<div className="col-md-8 mb-5">
							<h2>Ecco cosa pensano di me</h2>
							<p><u>Conoscere</u> la tecnologia è una gran cosa, <u>saperla usare</u> ancora meglio, <u>riuscire a condividerla</u> con i miei corsisti è soddisfazione pura!</p>
							<p>
								<i>Se hai partecipato come corsista puoi lasciarmi una recensione premendo <a href="/recensioni/new">qui</a></i>
							</p>
						</div>
					</div>
					<div className='mb-5'>
						
						<div className="row row-cols-1 row-cols-md-3 g-4">
							<MrlSingleReview state={this.state} color={this.getColor} />
						</div>
					</div>
					
				</div>
			</main>
		);
    }
}